import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LotteryProvider } from './contexts/LotteryContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <LotteryProvider>
      <App />
    </LotteryProvider>
  </React.StrictMode>
);
